export const citiesData = [
  { name: "Arlington Heights (North of Euclid Ave)", sedan: 70, suv: 90 },
  { name: "Arlington Heights (South of Euclid Ave)", sedan: 60, suv: 80 },
  { name: "Bannockburn", sedan: 75, suv: 95 },
  { name: "Buffalo Grove", sedan: 70, suv: 90 },
  { name: "Deer Park", sedan: 80, suv: 100 },
  { name: "Deerfield", sedan: 70, suv: 90 },
  { name: "Des Plaines", sedan: 50, suv: 70 },
  { name: "Evanston", sedan: 80, suv: 100 },
  { name: "Glencoe", sedan: 75, suv: 95 },
  { name: "Glenview", sedan: 65, suv: 85 },
  { name: "Golf", sedan: 65, suv: 85 },
  { name: "Hawthorn Woods", sedan: 80, suv: 100 },
  { name: "Highland Park", sedan: 75, suv: 95 },
  { name: "Highwood", sedan: 75, suv: 95 },
  { name: "Inverness", sedan: 80, suv: 100 },
  { name: "Killdeer", sedan: 80, suv: 100 },
  { name: "Lake Bluff", sedan: 80, suv: 100 },
  { name: "Lake Forest", sedan: 80, suv: 100 },
  { name: "Lake Zurich", sedan: 80, suv: 100 },
  { name: "Libertyville", sedan: 75, suv: 95 },
  { name: "Lincolnshire", sedan: 75, suv: 95 },
  { name: "Lincolnwood", sedan: 80, suv: 100 },
  { name: "Long Grove", sedan: 80, suv: 100 },
  { name: "Mettawa", sedan: 75, suv: 95 },
  { name: "Morton Grove", sedan: 60, suv: 80 },
  { name: "Mount Prospect", sedan: 60, suv: 80 },
  { name: "Mundelein", sedan: 80, suv: 100 },
  { name: "Niles", sedan: 50, suv: 70 },
  { name: "Northbrook", sedan: 70, suv: 90 },
  { name: "Northfield", sedan: 70, suv: 90 },
  { name: "Palatine", sedan: 75, suv: 95 },
  { name: "Park Ridge", sedan: 50, suv: 70 },
  { name: "Prospect Heights", sedan: 65, suv: 85 },
  { name: "Riverwoods", sedan: 70, suv: 90 },
  { name: "Rolling Meadows", sedan: 70, suv: 90 },
  { name: "Rosemont", sedan: 50, suv: 70 },
  { name: "Skokie", sedan: 70, suv: 90 },
  { name: "Vernon Hills", sedan: 75, suv: 95 },
  { name: "Wheeling", sedan: 65, suv: 85 },
  { name: "Wilmette", sedan: 75, suv: 95 },
  { name: "Winnetka", sedan: 75, suv: 95 }
];

export const whyChooseUs = [
  {
    title: "Reliable Service",
    description: "Professional airport transfers with punctual, dependable service."
  },
  {
    title: "Flat Rates by City",
    description: "Transparent pricing with no surprises. Know your cost upfront."
  },
  {
    title: "Professional Drivers",
    description: "Licensed, insured, and courteous chauffeurs for your comfort."
  }
];

export const contactInfo = {
  email: "goliveryrus@gmail.com",
  phone: "847-521-3270"
};